import React from 'react';
import {CommonEdit} from '../Common';
import {getInputs} from './Common';

export const DocumentEdit = props => <CommonEdit {...props} fields={getInputs()} />;
